export var iconClassNames = {
  filled: 'ui-icon__filled',
  outline: 'ui-icon__outline'
};
//# sourceMappingURL=iconClassNames.js.map
